<template>
  <div>
    <div class="groupBuying">
      <img class="img-info" v-if="pic" :src="pic" alt="" @click="changeImage">
      <div v-else class="info" @click="changeImage">
        <img class="icon-add" src="@/assets/images/common/icon-add.png" alt="">
        <span v-if="gShow" style="margin-top: 16px">上传自己的微信群二维码</span>
      </div>
    </div>
    <div v-show="dialog" class="dialog-view">
      <div class="dialog-wrap">
        <div v-if="gShow" class="tips" style="top: -60px">
          温馨提示
        </div>
        <div v-if="gShow" class="tips">
          请务必保持二维码完整且位于截图中央，</br>否则客户将无法识别进群！
        </div>
        <div style="width:100%;text-align: center;">
          <VueCropper
            ref="cropper2"
            :img="option.img"
            :outputSize="option.size"
            :outputType="option.outputType"
            :info="option.info"
            :full="option.full"
            :canMove="option.canMove"
            :canMoveBox="option.canMoveBox"
            :original="option.original"
            :autoCrop="option.autoCrop"
            :fixed="option.fixed"
            :fixedNumber="option.fixedNumber"
            :centerBox="option.centerBox"
            :infoTrue="option.infoTrue"
            :fixedBox="option.fixedBox"
            :high="true"
          ></VueCropper>
        </div>
        <div class="foot-btn">
          <van-button type="danger" @click="dialog = false">取消</van-button>
          <van-button type="warning" @click="finish" :loading="loadinges">保存</van-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import config from '@/config/index'
export default {
  props: {
    pic: {
      type: String,
      default: ''
    },
    gShow: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      dialog: false,
      fileList: [],
      picList: [],
      loadinges: false,
      option: {
        img: '', // 裁剪图片的地址
        info: true, // 裁剪框的大小信息
        outputSize: 0.8, // 裁剪生成图片的质量
        outputType: 'jpeg', // 裁剪生成图片的格式
        canScale: false, // 图片是否允许滚轮缩放
        autoCrop: true, // 是否默认生成截图框
        autoCropWidth: 1000, // 默认生成截图框宽度
        autoCropHeight: 1000, // 默认生成截图框高度
        fixedBox: false, // 固定截图框大小 不允许改变
        fixed: true, // 是否开启截图框宽高固定比例
        fixedNumber: [5,5], // 截图框的宽高比例
        full: true, // 是否输出原图比例的截图
        canMoveBox: false, // 截图框能否拖动
        original: false, // 上传图片按照原始比例渲染
        centerBox: true, // 截图框是否被限制在图片里面
        infoTrue: false, // true 为展示真实输出图片宽高 false 展示看到的截图框宽高
      }
    }
  },
  created () {
    let Url = window.location.href.split('#')[0]
    this.$api.user.getTicket({ url: encodeURIComponent(Url) }).then(data => {
      this.$wx.config({
        debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
        appId: config.appid, // 必填，公众号的唯一标识
        timestamp: data.timestamp, // 必填，生成签名的时间戳
        nonceStr: data.noncestr, // 必填，生成签名的随机串
        signature: data.signature, // 必填，签名
        jsApiList: ['chooseImage', 'uploadImage', 'getLocalImgData'] // 必填，需要使用的JS接口列表
      })
      this.$wx.error(function (res) {
        console.log(res)
      })
    })
  },
  methods: {
    dataURLtoBlob(dataurl) {
      var arr = dataurl.split(','),
      mime = arr[0].match(/:(.*?);/)[1],
      bstr = atob(arr[1]),
      n = bstr.length,
      u8arr = new Uint8Array(n)
      while (n--) {
        u8arr[n] = bstr.charCodeAt(n)
      }
      return new Blob([u8arr], { type: mime })
    },
    finish() {
      let _self = this
      this.$refs.cropper2.getCropData(data => {
        const blob = this.dataURLtoBlob(data)
        this.customRequest(blob)
        this.loading = true
        return false
      })
    },
    changeImage () {
      var that = this
      that.loadinges = false
      this.$wx.chooseImage({
        count: 1,
        sizeType: ['original', 'compressed'], // 可以指定是原图还是压缩图，默认二者都有
        sourceType: ['album', 'camera'], // 可以指定来源是相册还是相机，默认二者都有
        success: res => {
          const tempFilePaths = (res.localIds && res.localIds[0]) || ''
          if (!tempFilePaths) return
          this.$wx.getLocalImgData({
            localId: tempFilePaths,
            success: result => {
              // console.log(result)
              var localData = result.localData
              // console.log(localData, 123)
              if (localData.indexOf('data:image') != 0) {
                localData = 'data:image/jpeg;base64,' + localData
              }
              localData = localData.replace(/\r|\n/g, '').replace('data:image/jgp', 'data:image/jpeg')
              // console.log(localData, 234)
              that.dialog = true
              that.option.img = localData
            }
          })
        }
      })
      this.$wx.error(function (res) { })
    },
    customRequest(data) {
      this.loadinges = true
      let formData = new FormData();
      formData.append("file", data)
      this.$api.user.imgStreamUpload(formData).then(res => {
        this.$emit('successImg', res.data)
        this.loadinges = false
        this.dialog = false
      }).catch(res => {
        this.loadinges = false
      });
    }
  }
}
</script>

<style lang='less' scoped>
  .tips{
    font-size: 12px;
    color: #ffffff;
    text-align: center;
    position: relative;
    top: -50px;
  }
  .dialog-view{
    position: fixed;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    overflow: auto;
    margin: 0;
    z-index: 2001;
    background-color: rgba(0, 0, 0, 0.6);
  }
  .groupBuying{
    box-sizing: border-box;
    width: 92%;
    height: 115px;
    background: #FFFFFF;
    border-radius: 5px;
    margin: 0 auto;
    display: flex;
    align-items: center;
    padding-left: 15px;
    .img-info{
      width: 113px;
      height: 85px;
      border-radius: 3px;
    }
    .info{
      width: 113px;
      height: 85px;
      background: #F3F3F3;
      border-radius: 3px;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      font-size: 22/2px;
      color: #999999;
      .icon-add{
        width: 20px;
        height: 20px;
      }
    }
  }
  .van-overlay{
    z-index: 2001;
  }
  .upload-demo /deep/ .el-upload--picture-card {
    width: 5.625rem;
    height: 5.125rem;
    line-height: 5.125rem;
  }
  .groupBuying /deep/ .van-overlay {
    background-color: rgba(255, 255, 255, 0.8);
  }
  .popupimg {
    width: 100%;
    position: relative;
    top: 50%;
    transform: translateY(-50%);
    object-fit: contain;
  }
  .popuptitle {
    position: absolute;
    bottom: 22px;
    right: 15px;
  }
  .dialog-wrap{
    width: 100%;
    height: 100%;
    position: relative;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    .vue-cropper {
      width: 100%;
      height: 300px;
    }
    .foot-btn{
      box-sizing: border-box;
      width: 100%;
      display: flex;
      justify-content: space-between;
      padding: 0 20px;
      margin-top: 10px;
    }
  }
  /deep/.cropper-crop-box {
    position: relative !important;
    left: 10px !important;
    top: 10px !important;
  }

  /deep/.cropper-view-box {
    outline: 1px solid #e93b39;
    outline-color: #e93b39;
  }

  /deep/.cropper-box-canvas {
    position: relative !important;
    left: 10px !important;
    top: 10px !important;
  }

  /deep/.el-dialog__footer {
    text-align: center;
  }

  /deep/.el-dialog__header {
    text-align: center !important;
  }

  /deep/.el-upload--picture-card {
    border: 0px !important;
    background-color: #fff !important;
  }
</style>
